// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3uzIg","content":"LoadingAlert_content__3tVXv"};